import { METHOD, webRequest } from '../../client/HttpClient';
import { API } from '../../client/RouteConstants';
import { buildProductMetadataQuery, buildURL, logAPIErrorToNewrelic } from '../utils';
import { ACTION, Analytics } from '../../analytics/analytics';
import { APIResult } from '../APIResult';

export const deleteItemFromWishList = async (
    wishListId: string,
    skuId: string,
    productMetadata?: ProductMetadata | undefined,
): Promise<APIResult<WishListItem>> => {
    const productMetadataQuery = buildProductMetadataQuery(productMetadata);
    const url = buildURL(`${API.WISH_LISTS}/${wishListId}/items/${skuId}?lite=true${productMetadataQuery}`);

    const request: RequestInit = {
        method: METHOD.DELETE,
        headers: {
            'Content-Type': 'application/json',
            'x-api-client-id': 'add-to-wishlist-esi',
        },
        credentials: 'include',
    };

    const res = await webRequest(url, request);

    const result = new APIResult<WishListItem>();
    if (!res) {
        logAPIErrorToNewrelic(`deleteItemFromWishList`, `No response`, {
            skuId: skuId,
            wishListId: wishListId,
            ...request,
            url: url,
            productMetadata: productMetadata,
            response: res,
        });
        return result;
    }

    if (res.status === 401) {
        result.showError = false;
    }

    if (res.ok) {
        Analytics.dispatchAdobeAnalytics(ACTION.REMOVE_FROM_WISH_LIST);
        const customEvent = new CustomEvent('ADD_TO_WISHLIST_ESI:REMOVE_SUCCESS', {
            detail: {
                code: 'wishlist remove success',
            },
        });
        window.dispatchEvent(customEvent);
        result.data = await res.json();
        result.success = true;
    } else {
        const customEvent = new CustomEvent('ADD_TO_WISHLIST_ESI:ERROR', {
            detail: {
                code: 'wishlist remove error',
            },
        });
        window.dispatchEvent(customEvent);
        logAPIErrorToNewrelic(`deleteItemFromWishList`, `Not Ok response`, {
            skuId: skuId,
            wishListId: wishListId,
            request: request,
            reqUrl: url,
            productMetadata: productMetadata,
            ...res,
        });
    }

    return result;
};
